import React, { useState } from "react";
import {
  Modal,
  Form,
  Input,
  Button,
  notification,
  Row,
  Col,
  Space,
} from "antd";
import Joi from "joi";
import http from "../../../../helpers/http";
import axios from "axios";
import config from "../../../../config/config";
import _ from "lodash";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

const quillModules = {
  toolbar: {
    container: [
      ["bold", "italic", "underline", "strike"],
      [{ list: "ordered" }, { list: "bullet" }],
      [{ header: [1, 2, 3, false] }],
      [{ align: [] }],
      ["link"], // ✅ ONLY link
      ["clean"],
    ],
  },
};

const CreateFaq = ({ isVisible, handleClose, moduleName, base_url }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [formError, setFormError] = useState({});
  const [faqs, setFaqs] = useState([{ question: "", answer: "" }]); // default one FAQ

  const joiOptions = config.joiOptions;

  const validate = (values) => {
    const schemaObj = {
      title: Joi.string().min(1).required().label("Title"),
      faqs: Joi.array()
        .items(
          Joi.object({
            question: Joi.string().min(1).required().label("Question"),
            answer: Joi.string().min(1).required().label("Answer"),
          })
        )
        .min(1)
        .required()
        .label("FAQs"),
    };

    const { error } = Joi.object(schemaObj).validate(values, joiOptions);
    const errors = {};

    if (error) {
      error.details.forEach((field) => {
        const path = field.path.join(".");
        errors[path] = field.message;
      });
    }

    return errors;
  };

  const handleSubmit = async (values) => {
    const errors = validate({ ...values, faqs });
    setFormError(errors);
    if (Object.keys(errors).length > 0) return;

    setLoading(true);

    try {
      const response = await axios.post(`${base_url}/new`, { ...values, faqs });
      const data = response.data;

      if (Array.isArray(data)) {
        notification.success({ message: `${moduleName} Added Successfully` });
        form.resetFields();
        handleClose();
      } else {
        notification.error({
          message: "Unexpected Response",
          description: "API did not return expected array",
        });
      }
    } catch (err) {
      notification.error({
        message: "Add Failed",
        description: err.message,
      });
    } finally {
      setLoading(false);
    }
  };

  const handleAddFaq = () => setFaqs([...faqs, { question: "", answer: "" }]);
  const handleRemoveFaq = (index) =>
    setFaqs(faqs.filter((_, i) => i !== index));
  const handleFaqChange = (index, field, value) => {
    const newFaqs = [...faqs];
    newFaqs[index][field] = value;
    setFaqs(newFaqs);
  };

  return (
    <Modal
      title={`Add ${moduleName}`}
      visible={isVisible}
      onCancel={handleClose}
      okText="Create"
      cancelText="Cancel"
      confirmLoading={loading}
      onOk={() => {
        form
          .validateFields()
          .then((values) => handleSubmit(values))
          .catch(() => {});
      }}
      width={700}
    >
      <Form layout="vertical" form={form}>
        <Form.Item
          label="Title"
          name="title"
          {...(formError.title && {
            help: formError.title,
            validateStatus: "error",
          })}
        >
          <Input placeholder="Enter category title" />
        </Form.Item>

        {faqs.map((faq, index) => (
          <div
            key={index}
            style={{
              border: "1px solid #f0f0f0",
              padding: "10px",
              marginBottom: "10px",
              borderRadius: 5,
            }}
          >
            <Row gutter={16}>
              <Col xs={24}>
                <Form.Item
                  label={`Question ${index + 1}`}
                  required
                  {...(formError[`faqs.${index}.question`] && {
                    help: formError[`faqs.${index}.question`],
                    validateStatus: "error",
                  })}
                >
                  <Input
                    placeholder="Enter question"
                    value={faq.question}
                    onChange={(e) =>
                      handleFaqChange(index, "question", e.target.value)
                    }
                  />
                </Form.Item>
              </Col>

              <Col xs={24}>
                <Form.Item
                  label={`Answer ${index + 1}`}
                  required
                  {...(formError[`faqs.${index}.answer`] && {
                    help: formError[`faqs.${index}.answer`],
                    validateStatus: "error",
                  })}
                >
                  <ReactQuill
                    theme="snow"
                    value={faq.answer}
                    onChange={(value) =>
                      handleFaqChange(index, "answer", value)
                    }
                    modules={quillModules}
                    placeholder="Enter answer"
                  />
                </Form.Item>
              </Col>
            </Row>
            <Button
              danger
              onClick={() => handleRemoveFaq(index)}
              disabled={faqs.length === 1}
            >
              Remove
            </Button>
          </div>
        ))}

        <Button type="dashed" onClick={handleAddFaq} style={{ width: "100%" }}>
          Add Another FAQ
        </Button>
      </Form>
    </Modal>
  );
};

export default CreateFaq;
